import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function queryProcessApplyForm(_x) {
  return _queryProcessApplyForm.apply(this, arguments);
}
function _queryProcessApplyForm() {
  _queryProcessApplyForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request('/processApply/queryProcessApplyForm', METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryProcessApplyForm.apply(this, arguments);
}
export function getApplyProcessFormByFormId(_x2) {
  return _getApplyProcessFormByFormId.apply(this, arguments);
}
function _getApplyProcessFormByFormId() {
  _getApplyProcessFormByFormId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request('/processApply/getApplyProcessFormByFormId', METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _getApplyProcessFormByFormId.apply(this, arguments);
}
export function formFillSave(_x3) {
  return _formFillSave.apply(this, arguments);
}
function _formFillSave() {
  _formFillSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request('/processApply/formFillSave', METHOD.POST, data));
      }
    }, _callee3);
  }));
  return _formFillSave.apply(this, arguments);
}
export function copyformFillSave(_x4) {
  return _copyformFillSave.apply(this, arguments);
}
function _copyformFillSave() {
  _copyformFillSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request('/processApply/copyformFillSave', METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _copyformFillSave.apply(this, arguments);
}
export default {
  queryProcessApplyForm: queryProcessApplyForm,
  getApplyProcessFormByFormId: getApplyProcessFormByFormId,
  formFillSave: formFillSave,
  copyformFillSave: copyformFillSave
};